import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./NotesPlayed.module.scss";
import {useNotesPlayedLogic} from "./NotesPlayed.logic";
import {NotesPlayedDurationSwitcher} from "../notes-played-duration-switcher/NotesPlayedDurationSwitcher";
import BreakdownSection from "../../../components/dashboard/BreakdownSection";

export const NotesPlayed: VoidFunctionComponent = () => {
  const {correctNotes, incorrectNotes, totalNotes, percentCorrect, closeNotes} = useNotesPlayedLogic();
  return (
    <section className={s.container}>
      <div className={s.titleAndDuration}>
        <h2>Note accuracy</h2>
        <NotesPlayedDurationSwitcher />
      </div>
      <div className={s.accuracyBreakdown}>
        <BreakdownSection
          icon={`icon-note-correct`}
          barLabel={`Correct`}
          totalValue={totalNotes?.actualValue ?? 0}
          barValue={correctNotes?.actualValue ?? 0}
          barValueLabel={correctNotes?.labeledValue}
          barValueUnit={correctNotes?.unitLabel}
        />
        <BreakdownSection
          icon={`icon-note-close`}
          barLabel={`Close`}
          totalValue={totalNotes?.actualValue ?? 0}
          barValue={closeNotes?.actualValue ?? 0}
          barValueLabel={closeNotes?.labeledValue}
          barValueUnit={closeNotes?.unitLabel}
        />
        <BreakdownSection
          icon={`icon-note-incorrect`}
          barLabel={`Incorrect`}
          totalValue={totalNotes?.actualValue ?? 0}
          barValue={incorrectNotes?.actualValue ?? 0}
          barValueLabel={incorrectNotes?.labeledValue}
          barValueUnit={incorrectNotes?.unitLabel}
        />
      </div>
      <div className={s.totals}>
        <h3><span className={s.totalValue}>{totalNotes?.labeledValue ?? ``}</span><span className={s.unit}>{totalNotes?.unitLabel ?? ``}</span> <span className={s.totalLabel}>total</span></h3>
        <h3><span className={s.totalValue}>{percentCorrect?.labeledValue ?? ``}</span><span className={s.unit}>%</span> <span className={s.totalLabel}>correct</span></h3>
      </div>
    </section>
  );
}
